// mds-dojo — dijit/_editor/range — FAITHFUL port of references/dijit/_editor/range.js.
// W3C range helpers used by the editor (index<->node mapping, ancestor walks, etc.).
//
// ADAPTATIONS for this package:
//  - `dojo/_base/declare` import dropped: it was only used to declare the legacy IE
//    W3CRange shim.
//  - BROWSER-FORK COLLAPSE: the whole `if(!window.getSelection){ ...ie/W3CRange... }`
//    block (the IE6-8 range emulation: rangeapi.ie + rangeapi.W3CRange) is DEAD on every
//    evergreen browser (window.getSelection always exists) and is removed. Consequently
//    `create()` and `getSelection()` keep only their W3C branch. Nothing in RichText /
//    Editor / plugins references rangeapi.ie or rangeapi.W3CRange.
//  - lang.setObject("dijit.range", rangeapi) back-compat registration is kept.
import array from '../../dojo/_base/array'; // array.every
import lang from '../../dojo/_base/lang'; // lang.isArray, lang.setObject

// module:
//		dijit/_editor/range

var rangeapi: any = {
	// summary:
	//		W3C range API

	getIndex: function(/*DomNode*/ node: any, /*DomNode*/ parent: any){
		var ret: any[] = [], retR: any[] = [];
		var onode = node;

		var pnode, n;
		while(node != parent){
			var i = 0;
			pnode = node.parentNode;
			while((n = pnode.childNodes[i++])){
				if(n === node){
					--i;
					break;
				}
			}
			//if(i>=pnode.childNodes.length){
			//console.debug("Error finding index of a node in dijit/range.getIndex()");
			//}
			ret.unshift(i);
			retR.unshift(i - pnode.childNodes.length);
			node = pnode;
		}

		//normalized() can not be called so often to prevent
		//invalidating selection/range, so we have to detect
		//here that any text nodes in a row
		if(ret.length > 0 && onode.nodeType == 3){
			n = onode.previousSibling;
			while(n && n.nodeType == 3){
				ret[ret.length - 1]--;
				n = n.previousSibling;
			}
			n = onode.nextSibling;
			while(n && n.nodeType == 3){
				retR[retR.length - 1]++;
				n = n.nextSibling;
			}
		}

		return {o: ret, r:retR};
	},

	getNode: function(/*Array*/ index: any, /*DomNode*/ parent: any){
		if(!lang.isArray(index) || index.length == 0){
			return parent;
		}
		var node = parent;
		//	if(!node)debugger
		array.every(index, function(i: any){
			if(i >= 0 && i < node.childNodes.length){
				node = node.childNodes[i];
			}else{
				node = null;
				//console.debug('Error: can not find node with index',index,'under parent node',parent );
				return false; //terminate array.every
			}
			return true; //carry on the every loop
		});

		return node;
	},

	getCommonAncestor: function(n1: any, n2: any, root?: any){
		root = root || n1.ownerDocument.body;
		var getAncestors = function(n: any){
			var as: any[] = [];
			while(n){
				as.unshift(n);
				if(n !== root){
					n = n.parentNode;
				}else{
					break;
				}
			}
			return as;
		};
		var n1as = getAncestors(n1);
		var n2as = getAncestors(n2);

		var m = Math.min(n1as.length, n2as.length);
		var com = n1as[0]; //at least, one element should be in the array: the root (BODY by default)
		for(var i = 1; i < m; i++){
			if(n1as[i] === n2as[i]){
				com = n1as[i]
			}else{
				break;
			}
		}
		return com;
	},

	getAncestor: function(/*DomNode*/ node: any, /*RegEx?*/ regex: any, /*DomNode?*/ root?: any){
		root = root || node.ownerDocument.body;
		while(node && node !== root){
			var name = node.nodeName.toUpperCase();
			if(regex.test(name)){
				return node;
			}

			node = node.parentNode;
		}
		return null;
	},

	BlockTagNames: /^(?:P|DIV|H1|H2|H3|H4|H5|H6|ADDRESS|PRE|OL|UL|LI|DT|DE)$/,

	getBlockAncestor: function(/*DomNode*/ node: any, /*RegEx?*/ regex?: any, /*DomNode?*/ root?: any){
		root = root || node.ownerDocument.body;
		regex = regex || rangeapi.BlockTagNames;
		var block = null, blockContainer;
		while(node && node !== root){
			var name = node.nodeName.toUpperCase();
			if(!block && regex.test(name)){
				block = node;
			}
			if(!blockContainer && (/^(?:BODY|TD|TH|CAPTION)$/).test(name)){
				blockContainer = node;
			}

			node = node.parentNode;
		}
		return {blockNode:block, blockContainer:blockContainer || node.ownerDocument.body};
	},

	atBeginningOfContainer: function(/*DomNode*/ container: any, /*DomNode*/ node: any, /*Int*/ offset: any){
		var atBeginning = false;
		var offsetAtBeginning = (offset == 0);
		if(!offsetAtBeginning && node.nodeType == 3){ //if this is a text node, check whether the left part is all space
			if(/^[\s\xA0]+$/.test(node.nodeValue.substr(0, offset))){
				offsetAtBeginning = true;
			}
		}
		if(offsetAtBeginning){
			var cnode = node;
			atBeginning = true;
			while(cnode && cnode !== container){
				if(cnode.previousSibling){
					atBeginning = false;
					break;
				}
				cnode = cnode.parentNode;
			}
		}
		return atBeginning;
	},

	atEndOfContainer: function(/*DomNode*/ container: any, /*DomNode*/ node: any, /*Int*/ offset: any){
		var atEnd = false;
		var offsetAtEnd = (offset == (node.length || node.childNodes.length));
		if(!offsetAtEnd && node.nodeType == 3){ //if this is a text node, check whether the right part is all space
			if(/^[\s\xA0]+$/.test(node.nodeValue.substr(offset))){
				offsetAtEnd = true;
			}
		}
		if(offsetAtEnd){
			var cnode = node;
			atEnd = true;
			while(cnode && cnode !== container){
				if(cnode.nextSibling){
					atEnd = false;
					break;
				}
				cnode = cnode.parentNode;
			}
		}
		return atEnd;
	},

	adjacentNoneTextNode: function(startnode: any, next?: any){
		var node = startnode;
		var len = (0 - startnode.length) || 0;
		var prop = next ? 'nextSibling' : 'previousSibling';
		while(node){
			if(node.nodeType != 3){
				break;
			}
			len += node.length;
			node = node[prop];
		}
		return [node,len];
	},

	create: function(/*Window?*/ win?: any){	// TODO: for 2.0, replace optional window param w/mandatory window or document param
		win = win || window;
		return win.document.createRange();
	},

	getSelection: function(/*Window*/ window: any, /*Boolean?*/ ignoreUpdate?: any){
		return window.getSelection();
	}
};

// remove for 2.0
lang.setObject("dijit.range", rangeapi);

export default rangeapi;
